// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomGlassBox_wrapper__L+Nf6","shadow":"CustomGlassBox_shadow__sW9yi"};